import { FC, useEffect } from "react";

import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CardMediaVideoPlayerWithSpeedControls from "../../../pages/media-viewer/components/player/CardMediaVideoPlayerWithSpeedControls";
import DialogContent from "@mui/material/DialogContent";
import { errorNotification } from "../../variables/notification";

interface VideoDialogProps {
  videoUrl: string | null;
  expanded: boolean;
  fullWidth?: boolean;
  toggleExpand: () => void;
  savedScrollPosition?: number;
}

const VideoDialog: FC<VideoDialogProps> = ({
  videoUrl,
  expanded,
  toggleExpand,
  savedScrollPosition = 0,
}) => {
  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        window.scrollTo(0, savedScrollPosition);
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [savedScrollPosition]);

  return (
    <Dialog
      fullWidth
      open={expanded}
      onClose={toggleExpand}
      PaperProps={{
        sx: {
          margin: 0,
          maxWidth: "100%",
          maxHeight: "100%",
          width: "100%",
          height: "100%",
          backgroundColor: "transparent",
        },
      }}
    >
      <DialogContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "8px",
          padding: "0px",
          width: "100%",
          height: "100%",
          overflowY: "hidden",
        }}
        onClick={e => {
          if (e.target === e.currentTarget) {
            toggleExpand();
          }
        }}
      >
        {expanded && (
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                zIndex: 2,
              }}
              onClick={toggleExpand}
            >
              <IconButton onClick={toggleExpand}>
                <CloseIcon />
              </IconButton>
            </Box>

            <CardMediaVideoPlayerWithSpeedControls
              sx={{
                maxWidth: "80vw",
                maxHeight: "80vh",
                borderRadius: "8px",
              }}
              controls
              src={videoUrl ?? ""}
              autoPlay
              onError={() => {
                errorNotification("Error viewing video");

                toggleExpand();
              }}
            />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default VideoDialog;
